<mat-dialog-content fxLayout="column">
    <p [innerHtml]='message | safeHtml'></p>
    <mat-checkbox color="primary" [(ngModel)]="dontShowAgainChecked" style="margin-top: 16px;">
        Don't show this dialog again
    </mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button (click)="onNoClick()">No</button>
    <button mat-button cdkFocusInitial (click)="onYesClick()">Yes</button>
</mat-dialog-actions>
